module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.tripType,
    attrs: {
      "id": "right-panel"
    }
  }, [_c('div', {
    staticClass: "rightTop",
    class: {
      'oneDest': !_vm.hasDestinations
    }
  }, [(!_vm.galleryActive && _vm.currentDest) ? _c('a', {
    staticClass: "animated",
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    staticClass: "close-btn",
    attrs: {
      "src": require("../assets/times.png")
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeRightPanel()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imgWrap",
    style: ({
      backgroundImage: 'url(' + _vm.bgImg + ')'
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openGallery()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "destCont",
    class: {
      'galActive': _vm.galleryActive
    }
  }, [(!_vm.galleryActive) ? _c('div', {
    staticClass: "gallery-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openGallery()
      }
    }
  }, [_vm._v("View Gallery "), _c('div', {
    staticClass: "fa fa-external-link open-gallery-icon"
  })]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.currentDest.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentDest.content)
    }
  })])]), _vm._v(" "), (_vm.hasDestinations) ? _c('div', {
    staticClass: "rightBtm",
    class: _vm.tripType
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevDest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("explore"), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextDest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3192274"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightPanel.vue
// module id = 446
// module chunks = 1